module.exports = __webpack_public_path__ + "img/spotify.f64f7e95.svg";